<div *ngIf="!loading" class="animate-fade-in">
    <div class="product-list-controls__facet-list">
    <div>
        <select
            [(ngModel)]="selectedShippingDate"
            (change)="onShippingDateFilterChange()"
            class="w-full bg-white border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-primary-500/20 transition-all cursor-pointer hover:border-gray-300 shadow-sm"
        >
            <option [ngValue]="null">No limit (All)</option>
            <option *ngFor="let option of filterOptions" [value]="option.id">
                {{ option.label }}
            </option>
        </select>
    </div>
    </div>
</div>

<vsf-filter-skeleton
    *ngIf="loading"
    [showSearch]="false"
    [showCount]="false"
    [itemCount]="4"
    [ngClass]="filtersExpanded ? '' : 'hidden'"
></vsf-filter-skeleton>
